"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POST_ACCOUNT_DELETION_SESSION_KEY = void 0;
/** Session flag set after successful account deletion API, before client-only logout + thank-you redirect. Value: `candidate` | `company`. */
exports.POST_ACCOUNT_DELETION_SESSION_KEY = 'pracuj_post_account_deletion';
